<template>
  <div class="api-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-input
            v-model="searchInfo.frame_num"
            placeholder="请输入车架号"
            style="width: 210px; display: inline-block; margin-left: 10px"
            clearable
          ></el-input>
          <el-input
            v-model="searchInfo.license_num"
            placeholder="请输入车牌号"
            style="width: 210px; display: inline-block; margin-left: 10px"
            clearable
          ></el-input>
          <el-input
            v-model="searchInfo.person"
            placeholder="请输入经办人"
            style="width: 210px; display: inline-block; margin-left: 10px"
            clearable
          ></el-input>
          <el-select
            v-model="searchInfo.status"
            placeholder="请选择"
            style="width: 160px; display: inline-block; margin-left: 10px"
            clearable
          >
            <el-option label="未解决" :value="0"></el-option>
            <el-option label="已解决" :value="1"></el-option>
          </el-select>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="$router.push('addeditmaintain')"
            v-hasPermi="['维护记录', '新增']"
            >新增记录</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="frame_num"
          label="车架号"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="license_num" label="车牌号" align="center">
        </el-table-column>
        <el-table-column prop="problem" label="问题描述" align="center">
        </el-table-column>
        <el-table-column prop="create_time" label="提交时间" align="center">
        </el-table-column>
        <el-table-column prop="solve_time" label="解决时间" align="center">
        </el-table-column>
        <el-table-column prop="person" label="经办人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="经办人联系电话" align="center">
        </el-table-column>
        <el-table-column
          prop="solution"
          label="解决方案"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                style="margin-right: 10px"
                :style="{
                  color: scope.row.status === 1 ? '#67C23A' : '#F56C6C',
                }"
                >{{ scope.row.status === 1 ? "已解决" : "未解决" }}</span
              >
              <span
                class="btn read"
                v-hasPermi="['维护记录', '详情']"
                @click="
                  $router.push({ name: 'Status', query: { id: scope.row.id } })
                "
                >查看</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                @click="editClick(scope.row)"
                v-hasPermi="['维护记录', '编辑']"
                >编辑</span
              >
              <span
                class="btn read"
                style="color: #67c23a"
                @click="dealClick(scope.row.id)"
                v-hasPermi="['维护记录', '解决']"
                >解决</span
              >
              <span
                class="btn read"
                @click="deleteClick(scope.row.id)"
                v-hasPermi="['维护记录', '删除']"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="searchInfo.pageNum"
          :page-size="searchInfo.pageSize"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import { solveMaintain, getMaintains, delMaintains } from '@/api/maintain'
export default {
  data () {
    return {
      searchInfo: {
        frame_num: '',
        license_num: '',
        person: '',
        status: '',
        pageNum: 1,
        pageSize: 50
      },
      loading: false,
      options: [
        { name: '默认', sort: '' }
      ],
      table: {
        data: [],
        height: 100,
        total: 0
      },
      dealText: ''
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onresize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
  },
  methods: {
    //查询
    getData () {
      getMaintains(this.searchInfo).then(da => {
        this.table.data = da.data.content
        this.table.total = da.data.total
      })
    },
    search () {
      this.searchInfo.pageNum = 1
      this.getData()
    },
    currentChange () {
      this.getData()
    },
    handleSizeChange (e) {
      this.searchInfo.pageNum = 1
      this.searchInfo.pageSize = e
      this.getData()
    },
    editClick (val) {
      this.$router.push({ name: 'addEditMaintain', query: val })
    },
    dealClick (id) {
      MessageBox.prompt('请输入解决方案', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请输入',
        inputType: 'textarea'
      }).then(({ value }) => {
        solveMaintain({ id, solution: value }).then(da => {
          if (da.code === 0) {
            this.getData()
            this.$message.success('解决成功')
          }
        })
      })
    },
    deleteClick (id) {
      MessageBox.confirm('此操作将删除该维修记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = { id: id }
        delMaintains(param).then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功!')
            this.refresh()
          }
        })
      })
    },
    refresh () {
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
.api-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.api-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
